
import { defineComponent } from 'vue';
import VChart from 'vue-echarts';
import { BarChart, LineChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components';
import { use } from 'echarts/core';
import { CanvasRenderer, SVGRenderer } from 'echarts/renderers';
import { seriesChart } from '@/common/helpers/AccomplishedSegment';
import Overlay from '@/components/Overlay.vue';
import NoAccess from '@/components/NoAccess.vue';
import filters from '@/common/filters';

use([
  CanvasRenderer,
  BarChart,
  LineChart,
  SVGRenderer,
  GridComponent,
  TooltipComponent,
  TitleComponent,
  LegendComponent,
]);

export default defineComponent({
  name: 'DashboardAccomplishedSegment',
  components: {
    VChart,
    Overlay,
    NoAccess,
  },

  props: {
    accomplishedSegment: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },

    salesChannelName: {
      type: String,
      default: '',
    },

    access: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    accomplishedSegment: {
      handler() {
        this.setOptionsChart();
        this.legendChart = seriesChart(
          this.accomplishedSegment
        ).legendCarriedMask;
      },
      deep: true,
    },
  },

  methods: {
    setOptionsChart() {
      (this.$refs['chart'] as any).setOption({
        grid: {
          bottom: 40,
        },
        xAxis: [
          {
            type: 'category',
            data: seriesChart(this.accomplishedSegment).legendChart,
            axisTick: { show: false },
            splitLine: {
              show: false,
            },
            axisLabel: {
              padding: 28,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#4D4B4B',
              },
            },
          },
        ],
        series: [
          {
            name: 'Direct',
            type: 'line',
            step: 'middle',
            symbol: 'line',
            stack: 'a',
            xAxisIndex: 1,
            data: seriesChart(this.accomplishedSegment).stackSegmentBudgetValue,
            z: 1,
            lineStyle: {
              color: '#97928F',
              opacity: '0.25',
            },
            itemStyle: {
              color: '#97928F',
            },
            areaStyle: {
              opacity: '0.25',
            },
            label: {
              show: true,
              fontSize: this.$filters.isMobile() ? 8 : 10,
              yAxisIndex: 1,
              position: 'top',
              distance: 10,
              padding: 3,
              color: '#4D4B4B',
              formatter: (value) => {
                return seriesChart(this.accomplishedSegment)
                  .stackSegmentBudgetValueLegend[value.dataIndex];
              },
            },
          },
          {
            name: 'Direct',
            type: 'bar',
            stack: 'Acessórios',
            barWidth: 60,
            z: 2,
            data: seriesChart(this.accomplishedSegment)
              .stackSegmentRevenueValue,
            itemStyle: {
              color: '#FF9050',
            },
            label: {
              show: true,
              position: 'bottom',

              formatter: (value) => {
                return (
                  `{labelAmarela| ${
                    seriesChart(this.accomplishedSegment)
                      .stackSegmentInvoiceValueLegnd[value.dataIndex]
                  }}` +
                  '\n' +
                  `{labelLaranja| ${
                    seriesChart(this.accomplishedSegment)
                      .stackSegmentRevenueValueLegend[value.dataIndex]
                  }}`
                );
              },
              rich: {
                labelLaranja: {
                  color: '#FF6A13',
                  padding: 2,
                  fontSize: this.$filters.isMobile() ? 8 : 10.5,
                },
                labelAmarela: {
                  color: '#FFC700',
                  padding: 2,
                  fontSize: this.$filters.isMobile() ? 8 : 10.5,
                },
              },
            },
          },
          {
            name: 'Direct',
            type: 'bar',
            barWidth: '40%',
            stack: 'Acessórios',
            data: seriesChart(this.accomplishedSegment)
              .stackSegmentInvoiceValue,
            itemStyle: {
              color: '#FFC700',
              borderRadius: [4, 4, 0, 0],
            },
            label: {
              show: false,
              fontSize: 10,
              position: 'top',
              distance: 15,
              padding: -8,
              color: '#D2A503',
              formatter: (value) => {
                return seriesChart(this.accomplishedSegment)
                  .stackSegmentInvoiceValueLegnd[value.dataIndex];
              },
            },
          },
        ],
      });
    },
  },

  data() {
    return {
      legendChart: [] as any,
      options: {
        grid: {
          top: '10',
          left: '-37',
          right: '6%',
          bottom: '25%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisTick: { show: false },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#4A4B4D',
              },
            },
            axisLabel: {
              fontSize: filters.isMobile() ? 8 : 12,
            },
          },
          {
            type: 'category',
            show: false,
            boundaryGap: false,
            axisTick: { show: false },
            splitLine: {
              show: false,
            },
            axisLabel: {
              padding: 15,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#4A4B4D',
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            show: false,
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#989898',
              },
            },
          },
        ],
      },
    };
  },
});
